import { FC, ReactNode } from 'react';

import { DownloadLineIcon } from '../../../../../assets/icons/index';
import { useLocale } from '../../../../../hooks/index';

export type MobileNodeRowProps = {
  icon: ReactNode;
  name: string;
  onDownload?: () => void;
  onOpen?: () => void;
  subtitle?: ReactNode;
};

const ROW_BODY_CLASS = 'flex h-full min-w-0 flex-1 items-center gap-2 p-4 text-left';

export const MobileNodeRow: FC<MobileNodeRowProps> = ({
  icon,
  name,
  onDownload,
  onOpen,
  subtitle,
}) => {
  const { messagesLocale } = useLocale();
  const body = (
    <>
      {icon}
      <span className="flex min-w-0 flex-col">
        <span className="truncate text-sm font-[450] leading-5 text-gray-700">{name}</span>
        {subtitle && <span className="text-label-sm font-medium text-gray-500">{subtitle}</span>}
      </span>
    </>
  );

  return (
    <div className="flex h-[72px] items-center border-b border-gray-100 last:border-b-0">
      {onOpen ? (
        <button className={ROW_BODY_CLASS} onClick={onOpen} type="button">
          {body}
        </button>
      ) : (
        <div className={ROW_BODY_CLASS}>{body}</div>
      )}
      {onDownload && (
        <button
          aria-label={messagesLocale['DOWNLOAD']}
          className="flex h-full w-12 shrink-0 items-center justify-center"
          onClick={onDownload}
          type="button"
        >
          <DownloadLineIcon iconColor="#172335" />
        </button>
      )}
    </div>
  );
};
